import { render, staticRenderFns } from "./newSelect.vue?vue&type=template&id=d70fd34c&scoped=true&"
import script from "./newSelect.vue?vue&type=script&lang=js&"
export * from "./newSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70fd34c",
  null
  
)

export default component.exports